var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonRds32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-RDS_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-RDS_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Database",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.854,28.854 L7.708,33 L10.5,33 L10.5,34 L6.5,34 C6.224,34 6,33.777 6,33.5 L6,29.5 L7,29.5 L7,32.293 L11.147,28.147 L11.854,28.854 Z M33,29.5 L34,29.5 L34,33.5 C34,33.777 33.777,34 33.5,34 L29.5,34 L29.5,33 L32.293,33 L28.147,28.854 L28.854,28.147 L33,32.293 L33,29.5 Z M34,6.5 L34,10.5 L33,10.5 L33,7.708 L28.854,11.854 L28.147,11.147 L32.293,7 L29.5,7 L29.5,6 L33.5,6 C33.777,6 34,6.224 34,6.5 L34,6.5 Z M7,10.5 L6,10.5 L6,6.5 C6,6.224 6.224,6 6.5,6 L10.5,6 L10.5,7 L7.527,7 L11.846,11.14 L11.155,11.861 L7,7.88 L7,10.5 Z M32.726,19.4 C32.726,17.842 30.92,16.3 27.896,15.277 L28.216,14.33 C31.718,15.515 33.726,17.363 33.726,19.4 C33.726,21.437 31.718,23.286 28.216,24.471 L27.896,23.523 C30.92,22.5 32.726,20.958 32.726,19.4 L32.726,19.4 Z M7.737,19.4 C7.737,20.892 9.427,22.393 12.258,23.414 L11.918,24.354 C8.625,23.167 6.737,21.361 6.737,19.4 C6.737,17.439 8.625,15.633 11.918,14.445 L12.258,15.386 C9.427,16.407 7.737,17.908 7.737,19.4 L7.737,19.4 Z M20.023,15.719 C16.887,15.719 15.132,14.92 15.106,14.594 C15.132,14.268 16.887,13.469 20.023,13.469 C23.156,13.469 24.913,14.267 24.94,14.594 C24.913,14.92 23.156,15.719 20.023,15.719 L20.023,15.719 Z M20.023,19.274 C16.841,19.274 15.106,18.348 15.106,17.872 L15.106,15.842 C16.241,16.437 18.175,16.719 20.023,16.719 C21.871,16.719 23.805,16.437 24.94,15.842 L24.94,17.872 C24.94,18.348 23.205,19.274 20.023,19.274 L20.023,19.274 Z M20.023,23.011 C16.841,23.011 15.106,22.084 15.106,21.608 L15.106,19.265 C16.225,19.93 18.129,20.274 20.023,20.274 C21.917,20.274 23.821,19.93 24.94,19.265 L24.94,21.608 C24.94,22.084 23.205,23.011 20.023,23.011 L20.023,23.011 Z M20.023,26.29 C16.841,26.29 15.106,25.375 15.106,24.905 L15.106,23.001 C16.225,23.667 18.129,24.011 20.023,24.011 C21.917,24.011 23.821,23.667 24.94,23.001 L24.94,24.905 C24.94,25.375 23.205,26.29 20.023,26.29 L20.023,26.29 Z M20.023,12.469 C17.173,12.469 14.106,13.134 14.106,14.594 L14.106,24.905 C14.106,26.471 17.083,27.29 20.023,27.29 C22.963,27.29 25.94,26.471 25.94,24.905 L25.94,14.594 C25.94,13.134 22.873,12.469 20.023,12.469 L20.023,12.469 Z",
    id: "Amazon-RDS_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonRds32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-RDS_32.55c46bf5021c159382a3e54f85fd31ed.svg";
export { ForwardRef as ReactComponent };